module.exports = __webpack_public_path__ + "img/1a.51d584b7.png";